import styled from 'styled-components';

import { colors, fonts, device } from 'shared/defaultTheme';

export const ConfigCookieWrapper = styled.div`
  width: 100%;
  z-index: 101;

  @media ${device.sm} {
    top: 1px;
    height: 100%;
    position: fixed;
    display: flex;
    align-items: flex-end;
    .main-config-cookie {
      background: white;
      height: 200px;
      display: flex;
      justify-content: center;
    }
    .config-cookie-container {
      display: flex;
      align-items: center;
      width: 97%;
      flex-direction: column;
      align-items: center;
      margin-top: 6px;
    }
  }
  @media ${device.md} {
    top: 1px;
    height: 100%;
    position: fixed;
    display: flex;
    align-items: flex-end;
    .main-config-cookie {
      background: white;
      height: 200px;
      display: flex;
      justify-content: center;
    }
    .config-cookie-container {
      display: flex;
      align-items: center;
      width: 80%;
      flex-direction: column;
      align-items: center;
      margin-top: 6px;
    }
  }
  @media ${device.lg} {
    top: 1px;
    height: 100%;
    position: fixed;
    display: flex;
    align-items: flex-end;
    .main-config-cookie {
      background: white;
      height: 155px;
      display: flex;
      justify-content: center;
    }
    .config-cookie-container {
      display: flex;
      align-items: center;
      width: 80%;
      flex-direction: unset;
    }
  }
  @media ${device.xl} {
    top: 1px;
    height: 100%;
    position: fixed;
    display: flex;
    align-items: flex-end;
    .main-config-cookie {
      background: white;
      height: 155px;
      display: flex;
      justify-content: center;
    }
    .config-cookie-container {
      display: flex;
      align-items: center;
      width: 80%;
      flex-direction: unset;
    }
  }

  .config-cookie-span {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 24px;
  }

  .config-cookie-action {
    display: flex;
    flex-direction: column;
  }
  .button {
    width: 220px;
    height: 40px;
    margin-bottom: 12px;
  }
`;
